import { render, staticRenderFns } from "./CapitalOneSetPassword.vue?vue&type=template&id=6021a370&scoped=true&"
import script from "./CapitalOneSetPassword.vue?vue&type=script&lang=js&"
export * from "./CapitalOneSetPassword.vue?vue&type=script&lang=js&"
import style0 from "./CapitalOneSetPassword.vue?vue&type=style&index=0&id=6021a370&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6021a370",
  null
  
)

export default component.exports